import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SearchBar, Pagination, TableItemsPackage } from "../../components";
import { fetchDataPackage, setPage } from "../../store/slices/apiPackageSlice";
import AddModalPackage from "../Modals/AddModalPackage";
import { openModal, closeModal } from "../../store/slices/addModalSlice";
import TableItemsPackageResponsive from "../TableItemsPackage/TableItemsPackageResponsive";

const TablePackage = () => {
  const dispatch = useDispatch();
  const dataPackages = useSelector((state) => state.apiPackage.data);
  const totalCount = useSelector((state) => state.apiPackage.totalCount);
  const currentPage = useSelector((state) => state.apiPackage.currentPage);
  const isOpen = useSelector((state) => state.addModal.isOpen);

  const [searchInput, setSearchInput] = useState("");
  const prevSearchRef = useRef("");


  useEffect(() => {
    const pageToUse =
      prevSearchRef.current !== searchInput ? 1 : currentPage;
  
    if (prevSearchRef.current !== searchInput) {
      dispatch(setPage(1));
      prevSearchRef.current = searchInput;
    }
  
    dispatch(fetchDataPackage({ page: pageToUse, searchQuery: searchInput }));
  }, [dispatch, currentPage, searchInput]);

  const handleEditSuccess = () => {
    dispatch(fetchDataPackage({ page: currentPage, searchQuery: searchInput }));
  };

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(fetchDataPackage({ page: currentPage, searchQuery: searchInput }));
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  const openAddModal = () => {
    dispatch(openModal());
  };

  return (
    <div className="p-3 sm:p-6">
      <div className="flex flex-wrap items-center justify-between pb-4 bg-white dark:bg-gray-900 gap-3">
        <div className="flex-grow min-w-[250px]">
          <SearchBar
            searchInput={searchInput}
            handleSearchInputChange={handleSearchInputChange}
            handleSearchSubmit={handleSearchSubmit}
          />
        </div>
        <div className="flex-shrink-0">
          <button
            onClick={openAddModal}
            className="text-white  bg-blue-500 rounded-md border px-3 py-2"
            type="button"
          >
            Shto Pako
          </button>
        </div>
      </div>

      {isOpen && (
        <AddModalPackage
          title="Shto një pako"
          submitButtonText="Shto pakon"
          namePackage="Emri i pakosë"
          packageCategory="Zgjedh kategorinë"
          priceValue="Cmimi"
          adminValue="Cmimi i adminit"
          schoolValue="Cmimi i autoshkolles"
          onClose={handleCloseModal}
          onSuccess={handleEditSuccess}
        />
      )}

      <div
        className="relative overflow-x-auto shadow-md sm:rounded-lg"
        style={{ borderRadius: 1 }}
      >
        <div className="hidden sm:block">
          <table className="w-full min-w-[600px] text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Emri i Pakosë
                </th>
                <th scope="col" className="px-6 py-3">
                  Kategoria
                </th>
                <th scope="col" className="px-6 py-3">
                  Qmimi
                </th>
                <th scope="col" className="px-6 py-3">
                  Qmimi i autoshkollës
                </th>
                <th scope="col" className="px-6 py-3">
                  Qmimi i adminit
                </th>
                <th scope="col" className="px-6 py-3">
                  Muajt
                </th>
                <th scope="col" className="px-6 py-3">
                  Aksionet
                </th>
              </tr>
            </thead>
            <tbody>
              <TableItemsPackage dataPackage={dataPackages} />
            </tbody>
          </table>
        </div>

        <div className="block sm:hidden space-y-4">
          <TableItemsPackageResponsive dataPackage={dataPackages} />
        </div>
        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default TablePackage;
